import { render, staticRenderFns } from "./PainPoint.vue?vue&type=template&id=6dde468c&scoped=true&"
import script from "./PainPoint.vue?vue&type=script&lang=js&"
export * from "./PainPoint.vue?vue&type=script&lang=js&"
import style0 from "./PainPoint.vue?vue&type=style&index=0&id=6dde468c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde468c",
  null
  
)

export default component.exports